/* eslint-disable class-methods-use-this */
import { OidcClient, SigninResponse, WebStorageStateStore } from 'oidc-client-ts';
import { durtOidcScopes } from 'client/services/durtConstants';
import ConfigService from 'client/util/initializationHandler/ConfigService';
import CookieStateStore from 'client/services/cookieStateStore';
import type { IUiSettings } from 'client/util/initializationHandler/ConfigService';

export class OidcClientService {
  private initialize(host: string = window.location.host, config: IUiSettings = ConfigService) {
    return new OidcClient({
      authority: config.jcGoAuthority,
      client_id: config.jcGoClient,
      redirect_uri: `https://${host}/login/oidc_callback`,
      response_type: 'code',
      scope: durtOidcScopes.join(' '),
      stateStore: new WebStorageStateStore({ prefix: '_oidc_state_', store: new CookieStateStore() }),
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  async signin(userState?: any, host?: string): Promise<void> {
    const client = await this.getClient(host);
    return client.createSigninRequest({ state: userState }).then((req) => {
      window.location.replace(req.url);
    });
  }

  // eslint-disable-next-line arrow-body-style
  async processSigninResponse(host?: string): Promise<SigninResponse> {
    const client = await this.getClient(host);
    return client.processSigninResponse(window.location.href);
  }

  private async getClient(host?: string): Promise<OidcClient> {
    let hostname = window.location.host;
    if (host && typeof host === 'string' && host.trim()) {
      hostname = host.trim();
    }
    if (hostname !== window.location.host) {
      const uiSettings = await ConfigService.fetchUISettings(hostname);
      return this.initialize(hostname, uiSettings);
    }
    return this.initialize(hostname);
  }
}
export default new OidcClientService();
